export default __webpack_public_path__ + "static/media/TiendaNaranjaViajesLogo.0e49f582.svg";